export const aiDevBannerContentArabic = {
    mainHeading: "خدمات",
    greenHeading: "تطوير الذكاء الاصطناعي",
    greenSubHeading: "استفد من الذكاء الاصطناعي بالطريقة التي ينبغي أن تكون عليها.",
    sectionDescription: "حسن عملك باستخدام الأتمتة، وروبوتات الدردشة، والذكاء الاصطناعي التوليدي، والتطبيقات المخصصة، والتقارير المتقدمة، والمزيد. الإمكانيات لا حصر لها مع خدمات الذكاء الاصطناعي لدينا.",
    bannerButtonText: "هيا بنا نبدأ"
}

export const aiPowerSectionContentArabic = {
    heading: "أطلق العنان لقوة الذكاء الاصطناعي - طريقة Bitsclan",
    description:
        "لم تُحدث أي تقنية ثورة في مشهد الأعمال بشكل أعمق من الذكاء الاصطناعي في الثلاثين عامًا الماضية. اليوم، يُعد الذكاء الاصطناعي أكبر محفز للتحول في عالم الأعمال.",
    button: {
        text: "دعنا نتواصل",
        link: "/contact-us",
        iconClass: "fa-solid fa-arrow-right",
        iconStyle: {
            color: "#80B927",
            fontSize: "18px",
            marginTop: "4px",
        },
    },
    objectives: [
        {
            value: "1.3 تريليون دولار",
            label: "القيمة السوقية المقدرة للذكاء الاصطناعي بحلول عام 2032",
        },
        {
            value: "54%",
            label: "من الشركات قامت بتطبيق الذكاء الاصطناعي التوليدي في بعض مجالات أعمالها.",
            customStyle: { paddingInlineStart: "60px", paddingRight: "0px" },
        },
        {
            value: "415.81 مليار دولار",
            label: "القيمة المتوقعة لسوق الذكاء الاصطناعي في الولايات المتحدة وحدها بحلول نهاية هذا العقد",
        },
        {
            value: "7 من كل 10",
            label: "منظمات لديها برامج تدريب محددة للعاملين في مجال الذكاء الاصطناعي التوليدي",
            customStyle: { paddingInlineStart: "60px", paddingRight: "0px" },
        },
    ],
};

export const AiDevelopmentServicesDataArabic = {
    sectionContent: {
        mainHeading: "استفد من المستقبل مع خدمة تطوير الذكاء الاصطناعي لدينا",
        sectionDescription: "الذكاء الاصطناعي ليس مجرد تقنية؛ إنه المستقبل. يمكن لكل عمل اليوم استخدام الذكاء الاصطناعي لتعزيز الكفاءة التشغيلية، وأتمتة العمليات، وزيادة الإيرادات. السؤال هو كيف. هذا هو المكان الذي يأتي فيه Bitsclan IT Solutions. استكشف خدمات الذكاء الاصطناعي لدينا أدناه."
    },

    tabsData: [
        {
            id: "Tab1",
            label: "تطوير منتجات الذكاء الاصطناعي",
            content:
                "يُحدث الذكاء الاصطناعي ثورة في الصناعات، وتساعد خدمات تطوير منتجات الذكاء الاصطناعي لدينا الشركات على تسخير قوته لإنشاء حلول مبتكرة وذكية. نحن متخصصون في تطوير منتجات مدعومة بالذكاء الاصطناعي تعزز الكفاءة، وتؤتمت العمليات المعقدة، وتقدم تجارب مستخدم متميزة. سواء كانت أدوات أتمتة ذكية، أو حلول تحليلات تنبؤية، أو تطبيقات مدفوعة بالذكاء الاصطناعي، فإننا نضمن تكاملًا سلسًا لقدرات الذكاء الاصطناعي المصممة خصيصًا لاحتياجاتك الفريدة. يعمل فريقنا عن كثب مع العملاء من الفكرة إلى النشر، مما يضمن تصميم كل منتج للذكاء الاصطناعي من أجل قابلية التوسع والموثوقية والأداء.",
            secondContent: "بفضل الخبرة في التعلم الآلي، ومعالجة اللغة الطبيعية، والتعلم العميق، نقوم ببناء حلول ذكاء اصطناعي تدفع نمو الأعمال. سواء كنت تتطلع إلى تبسيط تفاعلات العملاء، أو تحسين عملية صنع القرار، أو تعزيز الكفاءة التشغيلية، فإن منتجاتنا المدفوعة بالذكاء الاصطناعي تمكّن الشركات بتقنيات متطورة. من روبوتات الدردشة المدعومة بالذكاء الاصطناعي ومحركات التوصية إلى أنظمة معالجة البيانات الذكية، نحول رؤيتك إلى حلول ذكاء اصطناعي عالية الأداء تقدم نتائج ملموسة.",
            btnText: "دعنا نناقش",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/ai-development/langchain-color.png",
                },
                {
                    img: "/images/services-icons/ai-development/open-cv.png",
                },
                {
                    img: "/images/services-icons/ai-development/SpaCy_logo.png",
                },
                {
                    img: "/images/services-icons/ai-development/TensorFlow_logo.png",
                },
            ],
        },
        {
            id: "Tab4",
            label: "حلول الأتمتة",
            content:
                "الأتمتة هي مفتاح تحقيق كفاءة أكبر وتقليل التكاليف التشغيلية في عالم اليوم الرقمي سريع الخطى. تساعد حلول الأتمتة المدفوعة بالذكاء الاصطناعي الشركات على تبسيط المهام المتكررة، وإزالة الأخطاء البشرية، وتحسين سير العمل. من خلال الاستفادة من أتمتة العمليات الروبوتية (RPA)، وإدارة سير العمل الذكية، واتخاذ القرارات المدفوعة بالذكاء الاصطناعي، نمكّن الشركات من تسريع الإنتاجية وتحرير الموارد القيمة. تم تصميم حلول الأتمتة لدينا للتكامل بسلاسة مع الأنظمة الحالية، مما يضمن الحد الأدنى من التعطيل مع زيادة الكفاءة والدقة إلى أقصى حد.",
            secondContent: "من روبوتات الدردشة لخدمة العملاء إلى معالجة المستندات المدعومة بالذكاء الاصطناعي وأتمتة سير العمل الذكية، تدفع حلولنا تحول الأعمال. سواء كنت بحاجة إلى إدخال بيانات تلقائي، أو الكشف عن الاحتيال، أو أتمتة العمليات الذكية، فإننا نطور أدوات مدفوعة بالذكاء الاصطناعي تعزز سرعة ودقة التشغيل. من خلال تطبيق حلول الأتمتة لدينا، يمكن للشركات تحسين تقديم الخدمات، وتعزيز إنتاجية الموظفين، والبقاء في صدارة المنافسة في مشهد آلي بشكل متزايد.",
            btnText: "دعنا نناقش",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/ai-development/langchain-color.png",
                },
                {
                    img: "/images/services-icons/ai-development/open-cv.png",
                },
                {
                    img: "/images/services-icons/ai-development/SpaCy_logo.png",
                },
                {
                    img: "/images/services-icons/ai-development/TensorFlow_logo.png",
                },
            ],
        },
        {
            id: "Tab5",
            label: "الذكاء الاصطناعي كخدمة",
            content:
                "لا يمتلك كل عمل الموارد أو الخبرة اللازمة لتطوير نماذج الذكاء الاصطناعي من الصفر، ولهذا السبب تجعل حلول الذكاء الاصطناعي كخدمة (AIaaS) الذكاء الاصطناعي في متناول الجميع. نحن نقدم نماذج ذكاء اصطناعي جاهزة للاستخدام وخدمات ذكاء اصطناعي قائمة على السحابة يمكن للشركات دمجها في أنظمتها الحالية دون تعقيد التطوير الداخلي. تتضمن عروض AIaaS لدينا تحليلات قائمة على التعلم الآلي، وأدوات أتمتة ذكية، وحلول مشاركة العملاء المدعومة بالذكاء الاصطناعي، وكلها مصممة للتوسع مع احتياجات عملك.",
            secondContent: "باستخدام حلول AIaaS لدينا، يمكنك الاستفادة من قوة الذكاء الاصطناعي للتحليلات التنبؤية، والكشف عن الاحتيال، والتوصيات المخصصة، والمزيد—بدون استثمار مقدم كبير. يضمن فريق الخبراء لدينا التكامل السلس، مما يسمح للشركات بتعزيز عملية صنع القرار، وأتمتة العمليات، ودفع الابتكار بسهولة. سواء كنت شركة ناشئة تتطلع إلى دمج الذكاء الاصطناعي في منتجك أو مؤسسة تسعى إلى قدرات ذكاء اصطناعي متقدمة، توفر حلول AIaaS لدينا طريقة فعالة من حيث التكلفة للبقاء في صدارة ثورة الذكاء الاصطناعي.",
            btnText: "دعنا نناقش",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/ai-development/langchain-color.png",
                },
                {
                    img: "/images/services-icons/ai-development/open-cv.png",
                },
                {
                    img: "/images/services-icons/ai-development/SpaCy_logo.png",
                },
                {
                    img: "/images/services-icons/ai-development/TensorFlow_logo.png"
                },
            ],
        },
        {
            id: "Tab6",
            label: "تكامل الذكاء الاصطناعي",
            content:
                "يمكن أن يؤدي دمج الذكاء الاصطناعي بسلاسة في أنظمتك الحالية إلى تحسين الكفاءة واتخاذ القرارات بشكل كبير. تساعد خدمات تكامل الذكاء الاصطناعي لدينا الشركات على تسخير الذكاء الاصطناعي لتعزيز تطبيقاتها، وسير العمل، وتجارب العملاء. سواء كنت بحاجة إلى أتمتة مدفوعة بالذكاء الاصطناعي، أو تحليلات تنبؤية، أو محركات توصية ذكية، فإننا نضمن تبني الذكاء الاصطناعي بسلاسة دون تعطيل عملياتك. يتخصص فريقنا في دمج قدرات الذكاء الاصطناعي في أنظمة إدارة علاقات العملاء (CRM)، ومنصات تخطيط موارد المؤسسات (ERP)، وتطبيقات الأعمال المخصصة لتحسين الأداء ومشاركة المستخدم.",
            secondContent: "من خلال دمج الذكاء الاصطناعي في بنيتك التحتية، يمكن للشركات الحصول على رؤى أعمق، وأتمتة المهام المتكررة، وإنشاء تجارب مستخدم مخصصة. من روبوتات الدردشة التي تعزز دعم العملاء إلى معالجة البيانات المدعومة بالذكاء الاصطناعي التي تحسن الدقة، تدفع حلول تكامل الذكاء الاصطناعي لدينا الابتكار والكفاءة. نضمن أن يتوافق الذكاء الاصطناعي مع أهداف عملك، مما يتيح اتخاذ قرارات أكثر ذكاءً وتحسين النتائج التشغيلية مع الحفاظ على الأمان وقابلية التوسع.",
            btnText: "دعنا نناقش",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/ai-development/langchain-color.png",
                },
                {
                    img: "/images/services-icons/ai-development/open-cv.png",
                },
                {
                    img: "/images/services-icons/ai-development/SpaCy_logo.png",
                },
                {
                    img: "/images/services-icons/ai-development/TensorFlow_logo.png",
                },
            ],
        },
        {
            id: "Tab7",
            label: "هندسة المحفزات",
            content:
                "تعتمد تفاعلات الذكاء الاصطناعي الفعالة على محفزات محسنة جيدًا تضمن استجابات دقيقة وذات صلة. تعمل خدمات هندسة المحفزات لدينا على تحسين مدخلات نموذج الذكاء الاصطناعي لتعزيز جودة الاستجابات في روبوتات الدردشة وأدوات الأتمتة وتطبيقات الذكاء الاصطناعي التوليدية. من خلال ضبط المحفزات لنماذج اللغة الكبيرة (LLMs) ومساعدي الذكاء الاصطناعي، نضمن أن تفهم أنظمة الذكاء الاصطناعي السياق، وتقلل من الغموض، وتقدم إجابات ذات مغزى ودقيقة.",
            secondContent: "تساعد خبرتنا في تصميم المحفزات الشركات على بناء أدوات مدفوعة بالذكاء الاصطناعي تعمل على تحسين تفاعلات العملاء، وأتمتة إنشاء المحتوى، وتبسيط أتمتة سير العمل. سواء كنت تقوم بتطوير روبوتات دردشة تعمل بالذكاء الاصطناعي لدعم العملاء أو استخدام الذكاء الاصطناعي لإنشاء محتوى ذكي، فإن محفزاتنا المحسنة تعزز جودة الاستجابة، مما يضمن أن تتواصل أنظمة الذكاء الاصطناعي بفعالية. نضمن أن تتوافق تفاعلات الذكاء الاصطناعي مع أهداف العمل، مما يوفر تجارب ذكاء اصطناعي ذكية وسهلة الاستخدام.",
            btnText: "دعنا نناقش",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/ai-development/langchain-color.png",
                },
                {
                    img: "/images/services-icons/ai-development/open-cv.png",
                },
                {
                    img: "/images/services-icons/ai-development/SpaCy_logo.png",
                },
                {
                    img: "/images/services-icons/ai-development/TensorFlow_logo.png",
                },
            ],
        },
        {
            id: "Tab8",
            label: "نماذج التحليلات التنبؤية",
            content:
                "في عالم اليوم القائم على البيانات، تحتاج الشركات إلى رؤى دقيقة للبقاء قادرة على المنافسة. تستخدم نماذج التحليلات التنبؤية لدينا الذكاء الاصطناعي والتعلم الآلي لتحليل البيانات التاريخية، وتحديد الأنماط، وتوليد تنبؤات تدفع اتخاذ القرارات المستنيرة. سواء كنت في قطاعات التمويل، أو الرعاية الصحية، أو التجزئة، أو أي صناعة أخرى، تساعد تحليلاتنا التنبؤية المدعومة بالذكاء الاصطناعي على تحسين العمليات، وتحسين تقييم المخاطر، واكتشاف فرص النمو. تم تصميم نماذجنا لمعالجة كميات هائلة من البيانات في الوقت الفعلي، وتقديم رؤى دقيقة وقابلة للتنفيذ.",
            secondContent: "من التنبؤ بالطلب وتحليل سلوك العملاء إلى الكشف عن الاحتيال والتنبؤ باتجاهات السوق، تمكّن حلول التحليلات التنبؤية لدينا الشركات من اتخاذ قرارات استباقية ومدعومة بالبيانات. من خلال الاستفادة من التنبؤ المدفوع بالذكاء الاصطناعي، يمكن للشركات تقليل المخاطر، وتحسين تخصيص الموارد، واكتساب ميزة تنافسية. تتعلم نماذجنا التنبؤية وتتكيف باستمرار، مما يضمن أن يظل عملك في صدارة اتجاهات السوق وطلبات العملاء.",
            btnText: "دعنا نناقش",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/ai-development/langchain-color.png",
                },
                {
                    img: "/images/services-icons/ai-development/open-cv.png",
                },
                {
                    img: "/images/services-icons/ai-development/SpaCy_logo.png",
                },
                {
                    img: "/images/services-icons/ai-development/TensorFlow_logo.png",
                },
            ],
        },
        {
            id: "Tab10",
            label: "معالجة اللغة الطبيعية",
            content:
                "تمكن معالجة اللغة الطبيعية (NLP) الآلات من فهم وتفسير اللغة البشرية، مما يحدث ثورة في كيفية تفاعل الشركات مع العملاء ومعالجة المعلومات. تساعد حلول NLP لدينا الشركات على تطوير روبوتات الدردشة المدعومة بالذكاء الاصطناعي، وأدوات تحليل المشاعر، وأنظمة التعرف على الكلام، وحلول معالجة المحتوى الآلية. من خلال الاستفادة من تقنيات NLP المتقدمة، نمكّن الشركات من استخراج رؤى من البيانات النصية والصوتية، وأتمتة تفاعلات العملاء، وتحسين كفاءة الاتصال الإجمالية.",
            secondContent: "نماذج NLP لدينا تشغل محركات البحث الذكية، والمساعدين الافتراضيين، وأدوات تحليل المستندات الآلية التي تعزز العمليات التجارية. سواء كنت بحاجة إلى روبوت دردشة يعمل بالذكاء الاصطناعي لدعم العملاء أو تحليل المشاعر لمراقبة العلامة التجارية، تضمن حلول NLP لدينا معالجة دقيقة وواعية للسياق للغة البشرية. من خلال دمج NLP في عملك، يمكنك تحسين مشاركة العملاء، وتحسين سير العمل، وتعزيز عملية صنع القرار بفهم اللغة المدعوم بالذكاء الاصطناعي.",
            btnText: "دعنا نناقش",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/ai-development/langchain-color.png",
                },
                {
                    img: "/images/services-icons/ai-development/open-cv.png",
                },
                {
                    img: "/images/services-icons/ai-development/SpaCy_logo.png",
                },
                {
                    img: "/images/services-icons/ai-development/TensorFlow_logo.png",
                },
            ],
        },
        {
            id: "Tab11",
            label: "الرؤية الحاسوبية",
            content:
                "تمكّن تقنية الرؤية الحاسوبية الآلات من تفسير وتحليل البيانات المرئية، مما يفتح إمكانيات جديدة في الأتمتة، والأمن، وذكاء الأعمال. تتضمن حلول الرؤية الحاسوبية المدعومة بالذكاء الاصطناعي لدينا التعرف على الصور، والكشف عن الكائنات، والتعرف على الوجه، وأنظمة الفحص البصري الآلية. تستخدم الشركات عبر الصناعات الرؤية الحاسوبية لتعزيز الأمان، وتحسين مراقبة الجودة، وأتمتة استخراج البيانات من الصور ومقاطع الفيديو.",
            secondContent: "من أنظمة المراقبة الذكية إلى ضمان الجودة المدعوم بالذكاء الاصطناعي في التصنيع، تعزز حلول الرؤية الحاسوبية لدينا الكفاءة التشغيلية والدقة. نحن نطور أنظمة معالجة الصور المدفوعة بالذكاء الاصطناعي لتطبيقات الرعاية الصحية، والتجزئة، والصناعة، مما يمكّن الشركات من تحليل المعلومات المرئية والتصرف بناءً عليها في الوقت الفعلي. سواء كنت بحاجة إلى تصنيف صور آلي، أو تحليل صور طبية، أو تتبع مخزون ذكي، فإن تقنية الرؤية الحاسوبية المتطورة لدينا تساعد الشركات على تحسين عملياتها.",
            btnText: "دعنا نناقش",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/ai-development/langchain-color.png",
                },
                {
                    img: "/images/services-icons/ai-development/open-cv.png",
                },
                {
                    img: "/images/services-icons/ai-development/SpaCy_logo.png",
                },
                {
                    img: "/images/services-icons/ai-development/TensorFlow_logo.png",
                },
            ],
        },
        {
            id: "Tab12",
            label: "التعلم العميق",
            content:
                "يُعد التعلم العميق في طليعة ابتكارات الذكاء الاصطناعي، حيث يدفع الأتمتة المتقدمة، والنمذجة التنبؤية، واتخاذ القرارات الذكية. تستفيد حلول التعلم العميق لدينا من الشبكات العصبية لمعالجة مجموعات البيانات الكبيرة، والتعرف على الأنماط، وتقديم تنبؤات دقيقة. تستخدم الشركات التعلم العميق لتطبيقات مثل التعرف على الكلام، والكشف عن الاحتيال، وأنظمة الذكاء الاصطناعي ذاتية التعلم، ومحركات التوصية. تضمن خبرتنا في التعلم العميق تسخير الشركات لقوته لتحسين العمليات وتعزيز تجارب العملاء.",
            secondContent: "باستخدام نماذج التعلم العميق، يمكن للشركات تحقيق دقة فائقة في تطبيقات الذكاء الاصطناعي، من توصيات المحتوى المخصصة إلى الأنظمة المستقلة. سواء كنت تتطلع إلى تطبيق تشخيص مدعوم بالذكاء الاصطناعي في الرعاية الصحية، أو منع الاحتيال في التمويل، أو الأتمتة الذكية في تجارة التجزئة، فإن حلول التعلم العميق لدينا توفر أداءً لا مثيل له. من خلال دمج التعلم العميق في عملك، يمكنك الوصول إلى قدرات ذكاء اصطناعي قوية تدفع الابتكار والكفاءة.",
            btnText: "دعنا نناقش",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/ai-development/langchain-color.png",
                },
                {
                    img: "/images/services-icons/ai-development/open-cv.png",
                },
                {
                    img: "/images/services-icons/ai-development/SpaCy_logo.png",
                },
                {
                    img: "/images/services-icons/ai-development/TensorFlow_logo.png",
                },
            ],
        },
        {
            id: "Tab13",
            label: "التعلم الآلي",
            content:
                "يحول التعلم الآلي البيانات الخام إلى رؤى ذكية، مما يساعد الشركات على أتمتة العمليات واتخاذ قرارات تعتمد على البيانات. تحلل نماذج التعلم الآلي المخصصة لدينا مجموعات البيانات المعقدة لتحديد الاتجاهات، واكتشاف الحالات الشاذة، وتحسين العمليات التجارية. سواء كنت تقوم ببناء محركات توصية مدعومة بالذكاء الاصطناعي، أو أنظمة كشف الاحتيال الآلية، أو أدوات الصيانة التنبؤية، فإن حلول التعلم الآلي لدينا توفر ذكاءً قويًا وقابلًا للتطوير مصممًا خصيصًا لاحتياجاتك.",
            secondContent: "من خلال تطبيق التعلم الآلي، يمكن للشركات تحسين الكفاءة، وتعزيز التخصيص، ودفع الأتمتة. تمتد خبرتنا عبر تقنيات التعلم الخاضع للإشراف، وغير الخاضع للإشراف، والتعلم المعزز، مما يضمن استفادة الشركات من الذكاء الاصطناعي لتحقيق أقصى تأثير. سواء كنت بحاجة إلى تجزئة العملاء، أو التنبؤ بالطلب، أو معالجة البيانات الذكية، تحول حلول التعلم الآلي لدينا البيانات إلى ذكاء أعمال قيم.",
            btnText: "دعنا نناقش",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/ai-development/langchain-color.png",
                },
                {
                    img: "/images/services-icons/ai-development/open-cv.png",
                },
                {
                    img: "/images/services-icons/ai-development/SpaCy_logo.png",
                },
                {
                    img: "/images/services-icons/ai-development/TensorFlow_logo.png",
                },
            ],
        },
    ]
}

export const aiDevelopmentBoxContentArabic = {
    heading: {
        part1: "ليس مجرد",
        highlighted: "شركة تطوير ذكاء اصطناعي",
        part2: "نحن شركاؤك في تحول الأعمال.",
    },
    paragraphs: [
        "بصفتنا شركة استشارات وتطوير ذكاء اصطناعي رائدة، لا نؤمن بالنهج الواحد الذي يناسب الجميع. نحن ندرك أن لكل عمل تحدياته واحتياجاته ومتطلباته الفريدة.",
        "وبالتالي، فإن حلول الذكاء الاصطناعي لدينا مصممة خصيصًا لضمان أفضل النتائج لعملائنا. سواء كان الأمر يتعلق بتحديث أنظمتك القديمة، أو دمج قدرات الذكاء الاصطناعي في منتجاتك الحالية، أو حلول تطوير الذكاء الاصطناعي المخصصة، فنحن نوفر لك التغطية الكاملة.",
    ],
    button: {
        text: "جدولة مكالمة",
        url: "https://calendly.com/bitsclansolutions/15min",
        iconClass: "fa-solid fa-arrow-right",
    },
};

export const IndustriesSectionContentArabic = {
    mainHeading: "ريادة التغيير",
    lightHeading: "عبر الصناعات",
    sectionDescription: "قيادة الابتكار وتحويل القطاعات من خلال الحلول والرؤى المتطورة."
}

export const AIDevPageSolutionsSectionArabic = {
    heading: "بناء حلول جاهزة للمستقبل من خلال",
    greenHeading: "خدمات تطوير الذكاء الاصطناعي",
    subHeading:
        "بصفتنا شركة متخصصة في تطوير الذكاء الاصطناعي، نحن الخبراء في مجال الذكاء الاصطناعي. خبراء الذكاء الاصطناعي لدينا هم من الأفضل في هذا المجال ولديهم سنوات من الخبرة في خدمات الأتمتة.",
    solutions: [
        {
            title: "التعلم الآلي",
            description:
                "بناء أنظمة ذكية باستخدام حلول التعلم الآلي التي تتعلم من البيانات. تشمل التطبيقات أنظمة التوصية، والصيانة التنبؤية، والكشف عن الاحتيال.",
        },
        {
            title: "التعلم العميق",
            description:
                "استفد من التعلم العميق لتحليل البيانات المعقدة. من التعرف على الصور والكلام إلى الأنظمة المستقلة، تحول حلول الذكاء الاصطناعي لدينا كيفية توجيه البيانات للقرارات.",
        },
        {
            title: "الرؤية الحاسوبية",
            description:
                "تمكين الآلات من تفسير المرئيات باستخدام خدمات تطوير الذكاء الاصطناعي. تشمل الاستخدامات الرئيسية التعرف على الوجوه، واكتشاف الكائنات، والتصوير الطبي، وعمليات الفحص.",
            noBorder: true,
        },
        {
            title: "معالجة اللغات الطبيعية (NLP)",
            description:
                "عزز التفاعلات باستخدام أدوات معالجة اللغات الطبيعية لروبوتات الدردشة، وتحليل المشاعر، والتعرف على الصوت، وترجمة اللغات، مما يخلق اتصالاً سلسًا بين الإنسان والذكاء الاصطناعي.",
        },
        {
            title: "أتمتة العمليات الروبوتية (RPA)",
            description:
                "أتمتة المهام المتكررة باستخدام حلول أتمتة العمليات الروبوتية. عزز الكفاءة، وقلل التكاليف، وتخلص من الأخطاء البشرية للتركيز على الأهداف الاستراتيجية بسير عمل أكثر ذكاءً.",
        },
        {
            title: "الشبكات العصبية التلافيفية (CNNs)",
            description:
                "استخدم الشبكات العصبية التلافيفية لمعالجة البيانات المرئية. مثالية للتعرف على الصور والفيديو، والتصوير الطبي، وإنشاء حلول ذكاء اصطناعي قوية للتحليل البصري المتقدم.",
            noBorder: true,
        },
    ],
};

export const AIDevWhyUsContentArabic = {
    heading: "لماذا تختار بيتسكلان كشركة لتطوير الذكاء الاصطناعي؟",
    subHeading:
        "بصفتنا شركة استشارات وتطوير ذكاء اصطناعي تركز على العملاء، نقدم خدمات تطوير ذكاء اصطناعي مخصصة لتلبية الاحتياجات الفريدة لمختلف الصناعات. تساعدك خبرتنا على الاستفادة من التقنيات المتقدمة لمواجهة التحديات والفرص الخاصة بصناعتك.",
    features: [
        {
            icon: "/images/premium.png",
            alt: "جودة",
            title: "الجودة لأنها",
            span: "تهم",
            description:
                "نقدم حلول ذكاء اصطناعي مصممة خصيصًا لاحتياجاتك. من خلال الاختبارات والتحقق الصارمين، نضمن نتائج موثوقة وعالية الجودة تدفع نتائج ذات مغزى.",
        },
        {
            icon: "/images/best-bred.png",
            alt: "أفضل الكفاءات",
            title: "أفضل",
            span: "المواهب",
            description:
                "يتكون فريقنا من أفضل الخبراء الذين يجمعون بين الابتكار والمعرفة التقنية. نحن نبتكر حلول تطوير ذكاء اصطناعي مخصصة باستخدام أحدث التقنيات لحل تحدياتك.",
        },
        {
            icon: "/images/time-zone.png",
            alt: "المنطقة الزمنية",
            title: "محاذاة",
            span: "المنطقة الزمنية",
            description:
                "نحن نتوافق مع منطقتك الزمنية لتوفير اتصال سلس واستجابات سريعة. يضمن التعاون في الوقت الفعلي التزام مشاريع الذكاء الاصطناعي الخاصة بك بالمواعيد النهائية بدقة.",
        },
        {
            icon: "/images/tech-upd.png",
            alt: "تقنية محدثة",
            title: "تقنية",
            span: "محدثة",
            description:
                "باستخدام تقنيات الذكاء الاصطناعي المتقدمة، نصمم حلولًا متطورة. يساعدنا البقاء على اطلاع دائم على تقديم الابتكار وخدمات تطوير الذكاء الاصطناعي الرائدة في الصناعة لك.",
        },
        {
            icon: "/images/conviction.png",
            alt: "قناعة",
            title: "قناعتنا",
            span: "",
            description:
                "نتولى ملكية مشاريعك بتفانٍ وتميز. حلول الذكاء الاصطناعي لدينا مصممة خصيصًا لأهدافك، مما يضمن تلبية أعلى المعايير.",
        },
    ],
    button: {
        text: "جدولة مكالمة",
        link: "https://calendly.com/bitsclan-it/30min?month=2025-01",
    },
};

export const AIDevRoadmapContentArabic = {
    mainHeading: "خارطة طريقنا المجربة ",
    greenHeading: "لضمان نجاحك",
    sectionDescription: "بصفتنا مزودًا رائدًا لخدمات تطوير الذكاء الاصطناعي، فقد قمنا بتطوير خارطة طريق منظمة لضمان نجاح مشاريعك. من الاكتشاف الأولي إلى الدعم المستمر، نتبع نهجًا منهجيًا يضمن التوافق مع أهداف عملك، ويوفر حلولًا عالية الجودة، ويوفر تحسينًا مستمرًا. إليك كيف نقوم بذلك:",

    leftColumn: [
        {
            title: "التصميم وإثبات المفهوم",
            description:
                "حوّل أفكارك إلى واقع من خلال إثبات مفهوم واضح. نقوم بتصميم معماريات والتحقق من الجدوى، مما يضمن تطوير ذكاء اصطناعي مخصص يناسب احتياجاتك.",
            className: "second",
        },
        {
            title: "التطوير والاختبار",
            description:
                "يقوم فريقنا ببناء أنظمة الذكاء الاصطناعي الخاصة بك واختبارها وتحسينها، مما يضمن وظائف سلسة. من خلال التحقق الصارم، نقدم خدمات تطوير ذكاء اصطناعي موثوقة وجاهزة للمستقبل.",
            className: "forth",
        },
    ],
    centerImages: {
        desktop: "/images/roadmap-fff.svg",
        tablet: "/images/roadmap-tablet/roadmap4-tab.png",
    },
    rightColumn: [
        {
            title: "الاكتشاف والتخطيط",
            description:
                "نتعاون لفهم أهدافك، وإنشاء خارطة طريق، ومواءمة حلول الذكاء الاصطناعي لدينا مع رؤية عملك، مما يضمن تخطيطًا سلسًا ونتائج عالية الجودة.",
            className: "first",
        },
        {
            title: "التنفيذ والدعم",
            description:
                "نجعل مشروعك ينبض بالحياة من خلال التنفيذ الخبير. من تحديد أهداف واضحة إلى تقديم الدعم المستمر، نضمن أن تكون حلول الذكاء الاصطناعي الخاصة بك محسّنة دائمًا.",
            className: "third",
        },
    ],
};

export const aiDevCoverTheStackArabic = {
    secondContent: {
        sectionDescription: "في Bitsclan، نضمن أن تكون عمليات ديف أوبس الخاصة بك مدعومة بأكثر التقنيات المتقدمة المتاحة. تم تصميم حزمة التقنيات المختارة بعناية لزيادة الكفاءة والأمان وقابلية التوسع في كل مرحلة من مراحل دورة حياة تطوير البرمجيات.",
        mainHeading: "حسّن تطوير الذكاء الاصطناعي الخاص بك باستخدام حزمة التقنيات الرائدة في الصناعة",
        defaultOpenTab: "المكتبات"
    },
    tabs: [
        "نماذج الذكاء الاصطناعي التوليدي",
        "الوحدات / مجموعات الأدوات",
        "أطر عمل التعلم العميق (DL)",
        "الشبكات العصبية",
        "المكتبات",
        "نماذج تصنيف الصور",
    ],

    tabItems: [
        {
            tab: "نماذج الذكاء الاصطناعي التوليدي",
            icon: "/images/genai1.svg",
            name: "CycleGAN",
        },
        {
            tab: "نماذج الذكاء الاصطناعي التوليدي",
            icon: "/images/genai2.svg",
            name: "DeepArt",
        },
        {
            tab: "نماذج الذكاء الاصطناعي التوليدي",
            icon: "/images/genai3.svg",
            name: "DeepDream",
        },
        { tab: "نماذج الذكاء الاصطناعي التوليدي", icon: "/images/genai4.svg", name: "VQ-VAE" },
        { tab: "نماذج الذكاء الاصطناعي التوليدي", icon: "/images/genai5.svg", name: "GPT-4" },
        { tab: "نماذج الذكاء الاصطناعي التوليدي", icon: "/images/genai6.svg", name: "GPT-3" },
        { tab: "نماذج الذكاء الاصطناعي التوليدي", icon: "/images/genai6.svg", name: "DALL-E" },
        { tab: "الوحدات / مجموعات الأدوات", icon: "/images/genai6.svg", name: "OpenAI GPT" },
        {
            tab: "الوحدات / مجموعات الأدوات",
            icon: "/images/genai6.svg",
            name: "OpenAI DALL-E",
        },
        {
            tab: "الوحدات / مجموعات الأدوات",
            icon: "/images/module1.svg",
            name: "DeepMind Sonnet",
        },
        {
            tab: "الوحدات / مجموعات الأدوات",
            icon: "/images/module2.svg",
            name: "Facebook AI Research ",
        },
        {
            tab: "الوحدات / مجموعات الأدوات",
            icon: "/images/module3.svg",
            name: "Hugging Face",
        },
        {
            tab: "الوحدات / مجموعات الأدوات",
            icon: "/images/module4.svg",
            name: "NVIDIA StyleGAN",
        },
        {
            tab: "أطر عمل التعلم العميق (DL)",
            icon: "/images/tech-icon.svg",
            name: "PyTorch",
        },
        {
            tab: "أطر عمل التعلم العميق (DL)",
            icon: "/images/tech-icon2.svg",
            name: "Keras",
        },
        {
            tab: "أطر عمل التعلم العميق (DL)",
            icon: "/images/tech-icon3.svg",
            name: "MXNet",
        },
        {
            tab: "أطر عمل التعلم العميق (DL)",
            icon: "/images/tech-icon4.svg",
            name: "TensorFlow",
        },
        {
            tab: "أطر عمل التعلم العميق (DL)",
            icon: "/images/tech-icon5.svg",
            name: "Caffe",
        },
        { tab: "الشبكات العصبية", icon: "/images/natural1.svg", name: "RBM" },
        { tab: "الشبكات العصبية", icon: "/images/natural2.svg", name: "DBN" },
        {
            tab: "الشبكات العصبية",
            icon: "/images/natural7.svg",
            name: "Transformers",
        },
        {
            tab: "الشبكات العصبية",
            icon: "/images/natural4.svg",
            name: "Autoencoders",
        },
        { tab: "الشبكات العصبية", icon: "/images/natural5.svg", name: "DRLN" },
        { tab: "الشبكات العصبية", icon: "/images/natural6.svg", name: "GAN" },
        { tab: "المكتبات", icon: "/images/tech-icon.svg", name: "PyTorch" },
        { tab: "المكتبات", icon: "/images/tech-icon2.svg", name: "Keras" },
        { tab: "المكتبات", icon: "/images/tech-icon3.svg", name: "MXNet" },
        { tab: "المكتبات", icon: "/images/libraries1.svg", name: "FastAI" },
        { tab: "المكتبات", icon: "/images/libraries2.svg", name: "TensorFlow" },
        { tab: "المكتبات", icon: "/images/libraries3.svg", name: "Theano" },
        { tab: "المكتبات", icon: "/images/libraries4.svg", name: "Scikit-learn" },
        {
            tab: "نماذج تصنيف الصور",
            icon: "/images/calsification.svg",
            name: "AlexNet",
        },
        {
            tab: "نماذج تصنيف الصور",
            icon: "/images/calsification2.svg",
            name: "EfficientNet",
        },
        {
            tab: "نماذج تصنيف الصور",
            icon: "/images/calsification3.svg",
            name: "Xception",
        },
        {
            tab: "نماذج تصنيف الصور",
            icon: "/images/calsification4.svg",
            name: "DenseNet",
        },
        {
            tab: "نماذج تصنيف الصور",
            icon: "/images/calsification5.svg",
            name: "Inception",
        },
        {
            tab: "نماذج تصنيف الصور",
            icon: "/images/calsification6.svg",
            name: "ResNet",
        },
        {
            tab: "نماذج تصنيف الصور",
            icon: "/images/calsification7.svg",
            name: "VGGNet",
        },
    ]
}

export const AiDevPageFaqDataArabic = {
    sectionContent: {
        mainHeading: "الأسئلة المتكررة",
        sectionDescription: "احصل على إجابات سريعة لأسئلتك حول عملية وخدمات تطوير الذكاء الاصطناعي لدينا.",
    },

    questionAnswer: [
        {
            id: "collapseOne",
            question: "ما هي خدمات تطوير الذكاء الاصطناعي؟",
            answer:
                "تشير خدمات تطوير الذكاء الاصطناعي إلى أي خدمات تستخدم الذكاء الاصطناعي لتطوير حلول جديدة أو تعديل الحلول الموجودة من خلال دمج الذكاء الاصطناعي لتحسين العمليات، وتقليل الأخطاء، وتحسين الإنتاجية، وزيادة المرونة، وتوسيع الإيرادات.",
        },
        {
            id: "collapseTwo",
            question: "كم تكلفة خدمة الذكاء الاصطناعي؟",
            answer:
                "تعتمد تكلفة خدمات الذكاء الاصطناعي التي تحتاجها على عوامل مثل نطاق المشروع، والتكنولوجيا المستخدمة، وما إلى ذلك. عادةً ما تتراوح تكلفة خدمة الذكاء الاصطناعي بين 5000 دولار و 300,000 دولار. وتقدم شركة Bitsclan IT Solutions، وهي شركة استشارات وتطوير ذكاء اصطناعي رائدة، استشارة مجانية للذكاء الاصطناعي.",
        },
        {
            id: "collapseThree",
            question: "كم يستغرق بناء منتج ذكاء اصطناعي؟",
            answer:
                "لا يوجد وقت محدد لتطوير منتج الذكاء الاصطناعي. ستحدد مدى تعقيد المنتج الوقت المطلوب لإكماله. قد يستغرق المنتج شديد التعقيد ذو الميزات المتقدمة ما يصل إلى 10 إلى 20 شهرًا. من ناحية أخرى، يمكن أن يستغرق المنتج البسيط ذو ميزات الذكاء الاصطناعي الدنيا ما يصل إلى 3 إلى 6 أشهر.",
        },
        {
            id: "fourth",
            question:
                "كيف يمكن أن يفيد دمج الذكاء الاصطناعي عملي؟",
            answer:
                "من خلال دمج الذكاء الاصطناعي، يمكن تحسين إجراءات اتخاذ القرار، وأتمتة المهام المتكررة، والحصول على رؤى تعتمد على البيانات. يمكن أيضًا استخدام الذكاء الاصطناعي للتنبؤ بالاتجاهات، وتحسين تخصيص الموارد، وتخصيص تجارب العملاء.",
        },
        {
            id: "fifth",
            question: "ما هي عملية الاستعانة بمصادر خارجية لخدمات تطوير الذكاء الاصطناعي؟",
            answer:
                "تتضمن الاستعانة بمصادر خارجية لتطوير الذكاء الاصطناعي الشراكة مع شركة متخصصة في الذكاء الاصطناعي للتعامل مع مشاريع الذكاء الاصطناعي الخاصة بك. تتضمن العملية عادةً الاستشارة الأولية، وجمع المتطلبات، وتخطيط المشروع، والتطوير، والاختبار، والتنفيذ، والدعم المستمر.",
        },
        {
            id: "sixth",
            question: "ما هي الصناعات التي يمكن أن تستفيد من خدمات تطوير الذكاء الاصطناعي؟",
            answer:
                "يمكن للعديد من الصناعات، بما في ذلك الرعاية الصحية، والتمويل، والتجزئة، والتصنيع، والخدمات اللوجستية، والعقارات، والقانونية، والتعليم، والإعلام، والزراعة، والألعاب، والطاقة، الاستفادة من خدمات تطوير الذكاء الاصطناعي.",
        },
        {
            id: "seventh",
            question:
                "هل يمكن دمج حلول الذكاء الاصطناعي مع أنظمتي وسير العمل الحاليين؟",
            answer:
                "نعم، يمكن دمج حلول الذكاء الاصطناعي بسلاسة مع أنظمتك وسير العمل الحاليين. يضمن خبراؤنا أن تكمل تقنية الذكاء الاصطناعي بنيتك التحتية الحالية، مما يعزز قدراتها دون تعطيل العمليات.",
        },
        {
            id: "eighteeth",
            question: "كيف تضمنون خصوصية البيانات وأمانها في مشاريع الذكاء الاصطناعي؟",
            answer:
                "نحن نعطي الأولوية لخصوصية البيانات وأمانها في جميع مشاريع الذكاء الاصطناعي لدينا. نحن ننفذ إجراءات أمنية قوية، ونلتزم بمعايير الصناعة، ونستخدم تقنيات التشفير وإخفاء الهوية لحماية بياناتك طوال دورة حياة المشروع.",
        },
    ],
};